export default __webpack_public_path__ + "static/media/transactionIcon.db5e7636.svg";